import { render, staticRenderFns } from "./UnsoldBillInfo.vue?vue&type=template&id=b6bd4e4c&scoped=true&"
import script from "./UnsoldBillInfo.vue?vue&type=script&lang=ts&"
export * from "./UnsoldBillInfo.vue?vue&type=script&lang=ts&"
import style0 from "./UnsoldBillInfo.vue?vue&type=style&index=0&id=b6bd4e4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bd4e4c",
  null
  
)

export default component.exports